import React from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../../utils/translate/i18n/useI18n";

import "./notFound.scss";

const NotFound: React.FC = () => {
  const { t } = useI18n();
  const navigate = useNavigate();

  return (
    <section className="not-found-page">
      <div className="not-found-page__panel card border-0">
        <div className="card-body p-4 p-md-5 text-center">
          <span className="not-found-page__badge badge rounded-pill mb-3">
            {t("Blad 404")}
          </span>
          <h2 className="not-found-page__title mb-3">{t("Nie znaleziono strony")}</h2>
          <p className="not-found-page__text mb-4">
            {t("Wpisany adres nie odpowiada zadnej stronie w tej aplikacji.")}
          </p>

          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <button className="btn btn-success" onClick={() => navigate("/")}>
              {t("Wroc do strony glownej")}
            </button>

          </div>
        </div>
      </div>
    </section>
  );
};

export default NotFound;